import { capitalize } from "@suse-o11y/capitalize";
import type { Result } from "@suse-o11y/result";

const COPY_FAILURE =
	"Copy to clipboard failed. Browser does not support automatic copying. You can copy manually using your keyboard.";

export async function copyToClipboard({
	text,
	label = "Data",
}: {
	text: string;
	label?: string;
}): Promise<Result<string, string>> {
	if (!(globalThis.isSecureContext && navigator.clipboard?.write)) {
		return [COPY_FAILURE, null];
	}

	try {
		await navigator.clipboard.write([
			new ClipboardItem({
				"text/plain": new Blob([text], { type: "text/plain" }),
			}),
		]);

		return [null, `${capitalize(label)} copied to clipboard.`];
	} catch {
		return [COPY_FAILURE, null];
	}
}
